import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './context/AuthContext';
import { NotificationsProvider } from './context/NotificationsContext';
import GlobalNav from './components/GlobalNav';
import BottomNav from './components/BottomNav';
import InstallBanner from './components/InstallBanner';
import Landing from './components/Landing';
import LoginPage from './components/LoginPage';
import RegisterPage from './components/RegisterPage';
import TicketsPage from './components/TicketsPage';
import AdminPage from './components/AdminPage';
import CouncilPage from './components/council/CouncilPage';
import BulletinPage from './components/BulletinPage';
import CalendarPage from './components/CalendarPage';
import ForumPage from './components/ForumPage';
import AmenitiesPage from './components/AmenitiesPage';
import HandbookPage from './components/HandbookPage';
import WeatherPage from './components/WeatherPage';
import SearchPage from './components/SearchPage';
import NotificationsPage from './components/NotificationsPage';
import AccountPage from './components/AccountPage';
import UnsubscribePage from './components/UnsubscribePage';
import TermsOfServicePage from './components/TermsOfServicePage';
import PrivacyPolicyPage from './components/PrivacyPolicyPage';
import { isPublicPath } from './lib/routes';

function Shell({ children }) {
  const { pathname } = useLocation();
  return (
    <div className="min-h-screen bg-background text-foreground" data-l-private={isPublicPath(pathname) ? undefined : ''}>
      {children}
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <NotificationsProvider>
          <Shell>
            <GlobalNav />
            <main>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/account" element={<AccountPage />} />
                <Route path="/admin" element={<AdminPage />} />
                <Route path="/admin/:condoSlug" element={<AdminPage />} />
                <Route path="/admin/:condoSlug/:tab" element={<AdminPage />} />
                <Route path="/council" element={<CouncilPage />} />
                <Route path="/council/:condoSlug" element={<CouncilPage />} />
                <Route path="/council/:condoSlug/:tab" element={<CouncilPage />} />
                <Route path="/approvals" element={<Navigate to="/admin?resume=1&tab=approvals" replace />} />
                <Route path="/forgot-password" element={<Navigate to="/login" replace />} />
                <Route path="/reset-password/:token" element={<Navigate to="/login" replace />} />
                <Route path="/unsubscribe/:token" element={<UnsubscribePage />} />
                <Route path="/terms" element={<TermsOfServicePage />} />
                <Route path="/privacy" element={<PrivacyPolicyPage />} />
                <Route path="/:condoSlug" element={<ForumPage />} />
                <Route path="/:condoSlug/tickets" element={<TicketsPage />} />
                <Route path="/:condoSlug/tickets/:ticketId" element={<TicketsPage />} />
                <Route path="/:condoSlug/bulletins" element={<BulletinPage />} />
                <Route path="/:condoSlug/calendar" element={<CalendarPage />} />
                <Route path="/:condoSlug/forum" element={<ForumPage />} />
                <Route path="/:condoSlug/forum/:postId" element={<ForumPage />} />
                <Route path="/:condoSlug/amenities" element={<AmenitiesPage />} />
                <Route path="/:condoSlug/handbook" element={<HandbookPage />} />
                <Route path="/:condoSlug/handbook/:itemId" element={<HandbookPage />} />
                <Route path="/:condoSlug/documents" element={<HandbookPage />} />
                <Route path="/:condoSlug/weather" element={<WeatherPage />} />
                <Route path="/:condoSlug/search" element={<SearchPage />} />
                <Route path="/:condoSlug/notifications" element={<NotificationsPage />} />
              </Routes>
            </main>
            <BottomNav />
            <InstallBanner />
          </Shell>
        </NotificationsProvider>
      </Router>
    </AuthProvider>
  );
}

export default App;

